import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react'
import { useRef } from 'react';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import AgGridTable from '../utilities/AgGridTable'
import ListPageHeader from '../utilities/ListPageHeader'
import ShowroomQuestinaries from './ShowroomQuestinaries';

const RevisionRequest = () => {
    const [error, setError] = useState();
    const [modalName, setModalName] = useState();
    const [open, setOpen] = useState(false);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const [status, setStatus] = useState();
    const perPage = 10;
    const [gridApi, setGridApi] = useState(null);
    const gridRef = useRef();
    const childRef = useRef();
    const [columnDefs, setColumnDefs] = useState([
        // { field: "id", headerName: "Sr .No", enableRowGroup: true },
        { field: "dsTaskId", headerName: "RequestID", enableRowGroup: true },
        { field: "partner", headerName: "Partner Name", enableRowGroup: true },
        { field: "showroom", headerName: "Showroom", enableRowGroup: true },
        { field: "designStudioCategory", headerName: "Type", enableRowGroup: true },
        { field: "createdDate", enableRowGroup: true, headerName: "Create Date" },
        // { field: "assignee", enableRowGroup: true, headerName: "Assignee" },
        { field: "dsStatus", enableRowGroup: true, headerName: "Status" },
    ]);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Users.xlsx',
            sheetName: 'Users'
        }
        // gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handleAddButton = (e) => {
        e.preventDefault();
        // setSelectedRows();
        // setOpen(true);
        // setModalName("Add User")
    }

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
        // params.api.sizeColumnsToFit();
        // window.addEventListener('resize', function () {
        //     setTimeout(function () {
        //       params.api.sizeColumnsToFit();
        //     });
        //   });      
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    const loadData = async () => {
        try {
            const list = await OAuthService.getList(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskList}?page=0&size=50`);
            const dsTaskData = list.data?._embedded?.dsTaskAssignments?.map((data, key) => {
                return data;
            });
            setRowData(dsTaskData);
        } catch (error) {
            setError(error.message);
        }
    }

    useEffect(() => {
        // if (gridApi) {
        loadData();
        // }
    }, []);

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onRowDoubleClicked = (params) => {
        setOpen(true);
        setModalName("Update Request")
    }

    const handleSave = () => {
        const childelement = childRef.current;
        const submitData = childelement.handleSubmit();
        submitData.then((val) => {
            if (val) {
                setOpen(false);
                loadData();
            }
        })
    }

    const checkedStatus = (st) => {
        setStatus(st)
    }


    return (
        <>
            <div className="h-full">
                <AgGridTable
                    columnDefs={columnDefs}
                    // onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    rowData={rowData}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'revisionRequestList'}
                />
            </div>

            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                onClose={handleClose}
                open={open}
            // {...other}
            >
                <DialogTitle>
                    <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                        <span>{modalName}</span>
                        <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                            <Button onClick={handleClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <ShowroomQuestinaries
                        id={selectedRows && selectedRows[0]?._links?.dsTaskAssignment?.href.split('/').pop()}
                        ref={childRef}
                        checkedStatus={checkedStatus}
                    />
                </DialogContent>
                <DialogActions className='flex justify-center '>
                    <div className='flex justify-center items-center space-x-8'>
                        {/* <Button variant="outlined" color="warning">Send to Partner </Button> */}
                        <Button variant="outlined" color="warning">Save as draft</Button>
                        <Button variant="contained" color="warning"
                            onClick={handleSave}
                            disabled={status}
                        >Submit</Button>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default RevisionRequest